import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { UserModel } from 'src/app/core/models/members/user/user.model';
import { InviteModalComponent } from 'src/app/shared/modals/invite-modal/invite-modal.component';


@Injectable({
  providedIn: 'root'
})
export class InviteModalService {
  
  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(inviteType: LoginType) {
    var model: any;
    var modalRef!: NgbModalRef;
   
    if(inviteType == LoginType.Client){
      model = new ClientModel(); 
    }else if(inviteType == LoginType.User){
      model = new UserModel(); 
    }

    modalRef = this.modalService.open( InviteModalComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.model = model;
    modalRef.componentInstance.inviteType = inviteType;
  }
}
